import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cookPrepareSmall",
  "use": "icon-cookPrepareSmall-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cookPrepareSmall\"><path d=\"M512 0A512 512 0 1 1 0 512 513.536 513.536 0 0 1 512 0z m0 967.168A455.168 455.168 0 1 0 56.832 512 456.448 456.448 0 0 0 512 967.168z m3.84-443.648l192.768 196.608a27.648 27.648 0 0 1 0 39.424 25.6 25.6 0 0 1-38.656 0l-200.96-204.8c-2.56 0-2.56-2.816-2.56-2.816s-2.816-2.816-2.816-5.632a21.248 21.248 0 0 1-2.816-11.264v-225.28a27.648 27.648 0 1 1 55.04 0z\" fill=\"#010101\" p-id=\"5246\" shape-rendering=\"geometricPrecision\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/cookPrepareSmall.svg
// module id = KW2u
// module chunks = 1